import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isNil } from 'lodash';

@Pipe({
  standalone: true,
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  public constructor(private sanitized: DomSanitizer) {}

  public transform(value: string | null | undefined = '') {
    const raw = isNil(value) || value === '' || value === 'null' ? '' : String(value);
    return this.sanitized.bypassSecurityTrustHtml(raw);
  }
}
